/*
 * air-elite.js — native behaviour for the converted pulsio-eu Pulsio ELITE page.
 * Replaces the Replo runtime for the interactions this page uses:
 *   1. Carousels (prev/next, dots, pointer drag) — transform based.
 *   2. Collapsibles / accordions (delivery, warranty, specs, FAQ).
 *   3. Buy box: colour swatch selection + add-to-cart (submits the /cart/add form).
 *   4. Product cards navigate to their product page on click.
 *   5. Sleek-style scroll reveals (CSS transitions + IntersectionObserver),
 *      incl. resuming paused Replo alchemy animations.
 * No external dependencies; idempotent per element.
 */
(function () {
  if (window.__airEliteInit) return;
  window.__airEliteInit = true;

  var TRANSITION = 'transform 450ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  var DRAG_THRESHOLD = 10;
  var REVEAL_OPTS = { rootMargin: '0px 0px -8% 0px', threshold: 0.15 };
  var STAGGER_MS = 80;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function currentX(track) {
    var m = /translate3d\(\s*(-?[\d.]+)px/.exec(track.style.transform || '');
    return m ? parseFloat(m[1]) : 0;
  }

  /* ---------- carousels ---------- */
  function initCarousel(root) {
    if (window.AirCarousel && window.AirCarousel.init) {
      return window.AirCarousel.init(root);
    }
  }

  /* ---------- collapsibles / accordions ---------- */
  function initCollapsible(root) {
    if (root.__airCollapsible) return;
    root.__airCollapsible = true;
    var trigger = root.querySelector('[role="button"][aria-controls]');
    if (!trigger) return;
    var contentId = trigger.getAttribute('aria-controls');
    var content = contentId ? document.getElementById(contentId) : null;
    if (!content) {
      // fallback: the sibling element after the trigger
      content = trigger.nextElementSibling;
    }
    function isOpen() { return root.getAttribute('data-state') === 'open'; }
    function setOpen(open) {
      root.setAttribute('data-state', open ? 'open' : 'closed');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (content) {
        if (open) { content.removeAttribute('hidden'); content.setAttribute('aria-expanded', 'true'); }
        else { content.setAttribute('hidden', ''); content.setAttribute('aria-expanded', 'false'); }
      }
    }
    var toggle = function (e) {
      if (e) e.preventDefault();
      setOpen(!isOpen());
    };
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') toggle(e);
    });
  }

  /* ---------- buy box: swatches + add to cart ---------- */
  var SWATCH_SELECTED = {
    'r-zokdik': 'r-g33lg7',
    'r-1ccxm3w': 'r-17nri8z',
    'r-1mhdul7': 'r-1s3tukd',
  };

  function readVariantData() {
    var el = document.getElementById('air-elite-variant-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function containerOf(el) {
    return el.closest('[data-replo-product-container]') || el.closest('[id^="replo-section-"]') || document;
  }
  function formOf(scope) {
    return (scope.querySelector ? scope : document).querySelector(
      'form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
    );
  }
  function setFormVariant(scope, id) {
    var form = formOf(scope);
    if (!form || !id) return;
    var input = form.querySelector('input[name="id"]');
    if (input) input.value = id;
  }
  function swatchSelectedClass(opt) {
    var classes = (opt.className || '').split(/\s+/);
    for (var i = 0; i < classes.length; i++) {
      if (SWATCH_SELECTED[classes[i]]) return SWATCH_SELECTED[classes[i]];
    }
    for (var j = 0; j < classes.length; j++) {
      if (classes[j].indexOf('r-') === 0 && !SWATCH_SELECTED[classes[j]]) return classes[j];
    }
    return null;
  }
  function setSwatchVisual(opts, active) {
    Array.prototype.forEach.call(opts, function (opt) {
      var on = opt === active;
      opt.setAttribute('aria-selected', on ? 'true' : 'false');
      var selectedClass = swatchSelectedClass(opt);
      if (selectedClass) opt.classList.toggle(selectedClass, on);
    });
  }
  function updateColourLabel(container, value) {
    if (!value) return;
    var label = container.querySelector('.r-492l7h span, .r-492l7h');
    if (label) label.textContent = value;
  }
  function imageUrlWithWidth(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.href;
    } catch (e) {
      return url;
    }
  }
  function updateGalleryImage(container, url) {
    if (!url || !container) return;
    var picture = container.querySelector('picture.r-7r43m1');
    if (!picture) return;
    picture.style.setProperty('--replo-attributes-currentitem', url);
    var img = picture.querySelector('img.r-6splqb, img');
    if (img) img.src = url;
    Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
      var media = source.getAttribute('media') || '';
      var width = 1042;
      if (media.indexOf('max-width: 640px') !== -1) width = 820;
      else if (media.indexOf('1024px') !== -1) width = 1024;
      source.srcset = imageUrlWithWidth(url, width);
    });
  }
  function initSwatches(scope, data) {
    (scope || document).querySelectorAll('[data-replo-option-select]').forEach(function (listbox) {
      if (listbox.__airSwatch) return;
      listbox.__airSwatch = true;
      var opts = Array.prototype.slice.call(listbox.querySelectorAll('[role="option"]'));
      if (!opts.length) return;
      var container = containerOf(listbox);
      function select(opt, idx) {
        setSwatchVisual(opts, opt);
        if (data && data.optionValues && data.byValue) {
          var val = data.optionValues[idx];
          var id = val != null ? data.byValue[val] : null;
          if (id) setFormVariant(container, id);
          updateColourLabel(container, val);
          if (data.imageByValue && val != null && data.imageByValue[val]) {
            updateGalleryImage(container, data.imageByValue[val]);
          }
        }
        // Never let a sold-out sync failure abort swatch wiring.
        try {
          if (window.AirSoldOut) window.AirSoldOut.syncContainer(container);
        } catch (err) {}
      }
      var initiallySelected = -1;
      opts.forEach(function (opt, idx) {
        var handler = function (e) {
          if (e) e.preventDefault();
          select(opt, idx);
        };
        opt.style.cursor = 'pointer';
        opt.addEventListener('click', function (e) {
          handler(e);
          opt.blur();
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            handler(e);
            opt.blur();
          }
        });
        if (opt.getAttribute('aria-selected') === 'true') initiallySelected = idx;
      });
      // Run the initial selection AFTER every option is wired, so any throw
      // inside select() can't strand the remaining click handlers.
      if (initiallySelected >= 0) {
        try { select(opts[initiallySelected], initiallySelected); } catch (err) {}
      }
    });
  }
  function initBuyBox(section) {
    if (section.__airBuyBox) return;
    section.__airBuyBox = true;
    var data = readVariantData();
    initSwatches(section, data);

    section.querySelectorAll('[data-replo-add-product-variant-to-cart]').forEach(function (btn) {
      if (btn.__airAtc) return;
      btn.__airAtc = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var container = containerOf(btn);
        var form = formOf(container);
        if (!form) { window.location.href = '/cart'; return; }
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  }

  /* ---------- scroll reveals + alchemy ---------- */
  function hasAlchemyPaused(el) {
    var cs = getComputedStyle(el);
    return cs.animationName && cs.animationName.indexOf('alchemy') !== -1 && cs.animationPlayState === 'paused';
  }
  function hasBackgroundImage(el) {
    if ((el.style.backgroundImage || '').indexOf('url') !== -1) return true;
    var cs = getComputedStyle(el);
    return cs.backgroundImage && cs.backgroundImage !== 'none';
  }
  function isInView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.92 && r.bottom > 0;
  }
  function revealEl(el) {
    if (el.__airRevealed) return;
    el.__airRevealed = true;
    el.classList.remove('air-reveal-pending');
    el.classList.add('air-reveal-visible');
  }
  function tagReveal(el, variant, delayMs) {
    if (el.__airRevealTagged) return;
    el.__airRevealTagged = true;
    el.setAttribute('data-air-reveal', variant || 'fade-up');
    if (delayMs) el.style.setProperty('--air-reveal-delay', delayMs + 'ms');
    el.classList.add('air-reveal-pending', 'air-reveal--' + (variant || 'fade-up'));
    if (reducedMotion || isInView(el)) { revealEl(el); return null; }
    return el;
  }
  function initAirMotion() {
    var toObserve = [];
    var alchemyBg = [];
    function observe(el) { if (el && !el.__airRevealed) toObserve.push(el); }

    document.querySelectorAll('[data-air-reveal]').forEach(function (el) {
      if (el.__airRevealTagged) return;
      var variant = el.getAttribute('data-air-reveal') || 'fade-up';
      var delay = parseInt(el.getAttribute('data-air-reveal-delay') || '0', 10);
      observe(tagReveal(el, variant, delay));
    });

    document.querySelectorAll('[id^="replo-section-"]').forEach(function (section) {
      section.querySelectorAll('[data-replo-carousel]').forEach(function (carousel) {
        if (hasAlchemyPaused(carousel) && hasBackgroundImage(carousel)) { alchemyBg.push(carousel); return; }
        observe(tagReveal(carousel, 'fade-up', 0));
      });
      var gridIndex = 0;
      section.querySelectorAll('[data-replo-product-handle]').forEach(function (card) {
        if (card.closest('[data-replo-carousel]')) return;
        if (hasAlchemyPaused(card)) return;
        var parent = card.parentElement;
        if (parent && hasAlchemyPaused(parent)) return;
        observe(tagReveal(card, 'fade-up', gridIndex * STAGGER_MS));
        gridIndex++;
      });
      section.querySelectorAll('.trustpilot-widget').forEach(function (widget) {
        var wrap = widget.parentElement;
        if (!wrap || wrap.__airRevealTagged) return;
        observe(tagReveal(wrap, 'fade', 0));
      });
    });

    var nodes = document.querySelectorAll('[data-rid]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.__airRevealTagged || node.closest('[data-replo-carousel]')) continue;
      if (!hasAlchemyPaused(node)) continue;
      if (hasBackgroundImage(node)) { alchemyBg.push(node); continue; }
      node.classList.add('air-reveal--alchemy-override');
      observe(tagReveal(node, 'fade-up', 0));
    }

    function playAlchemy(el) { el.style.animationPlayState = 'running'; }
    if (alchemyBg.length) {
      if (!('IntersectionObserver' in window) || reducedMotion) {
        alchemyBg.forEach(playAlchemy);
      } else {
        var alchemyIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { playAlchemy(e.target); alchemyIo.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
        alchemyBg.forEach(function (el) { if (isInView(el)) playAlchemy(el); else alchemyIo.observe(el); });
      }
    }

    if (!toObserve.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) { toObserve.forEach(revealEl); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { revealEl(e.target); io.unobserve(e.target); } });
    }, REVEAL_OPTS);
    toObserve.forEach(function (el) { if (isInView(el)) revealEl(el); else io.observe(el); });
  }

  function initProductNav(scope) {
    var cards = (scope || document).querySelectorAll('[data-replo-product-handle]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.__airNav) return;
      var handle = (card.getAttribute('data-replo-product-handle') || '').trim();
      if (!handle || handle === 'empty-product') return;
      // skip the main buy-box container (it holds the add-to-cart form)
      if (card.querySelector('form[action="/cart/add"]')) return;
      card.__airNav = true;
      card.style.cursor = 'pointer';
      card.addEventListener('click', function (e) {
        if (e.target.closest('a[href], button, [role="button"], [role="option"], [data-replo-part="nav-button"], [aria-label^="Go to slide"], form')) return;
        window.location.href = '/products/' + handle;
      });
    });
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-replo-carousel]'), initCarousel);
    Array.prototype.forEach.call(document.querySelectorAll('[data-replo-collapsible]'), initCollapsible);
    Array.prototype.forEach.call(document.querySelectorAll('[id^="replo-section-"]'), initBuyBox);
    initProductNav(document);
    initAirMotion();
  });
})();
